import { useState } from 'react';
import { Modal, Input, InputNumber } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export default function ModalActualizarReembolso({ visible, onClose, onConfirm, loading }) {
  const [monto, setMonto] = useState(null);
  const [motivoReembolso, setMotivoRechazo] = useState('');
  const [motivoAceptacion, setMotivoAceptacion] = useState('');

  const handleOk = () => {
    if (monto && motivoReembolso.trim() && motivoAceptacion.trim()) {
      onConfirm({ monto, motivoReembolso, motivoAceptacion });
    }
  };

  const handleCancel = () => {
    setMonto(null);
    setMotivoRechazo('');
    setMotivoAceptacion('');
    onClose();
  };

  return (
    <Modal
      title={
        <span>
          <EditOutlined style={{ marginRight: 8 }} />
          Actualizar Reembolso
        </span>
      }
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Actualizar"
      cancelText="Cancelar"
      okButtonProps={{ disabled: !monto || !motivoReembolso.trim() || !motivoAceptacion.trim(), danger: true }}
      className="pagos-v2-modal"
    >
      <p>Monto:</p>
      <InputNumber
        style={{ width: '100%' }}
        value={monto}
        onChange={(value) => setMonto(value)}
        placeholder="Monto"
      />
      <p style={{ marginTop: 16 }}>Motivo de Reembolso:</p>
      <Input.TextArea
        rows={3}
        value={motivoReembolso}
        onChange={(e) => setMotivoRechazo(e.target.value)}
        placeholder="Motivo de reembolso..."
      />
      <p style={{ marginTop: 16 }}>Motivo de Aceptación:</p>
      <Input.TextArea
        rows={3}
        value={motivoAceptacion}
        onChange={(e) => setMotivoAceptacion(e.target.value)}
        placeholder="Motivo de aceptación..."
      />
    </Modal>
  );
}
